export const messages = {
  en: {
    affiliateUserManage: {
      queryCondition: 'Query Conditions',
      pleaseInputAffiliateUser: 'Please input affiliate user',
      query: 'Query',
      affiliateUser: 'Affiliate User',
      affiliateUserId: 'Affiliate User ID',
      ruleId: 'Rule ID',
      relatedUserId: 'Related User ID',
      parentAffiliateUserId: 'Parent Affiliate User ID',
      parentAffiliateUser: 'Parent Affiliate User',
      affiliateLevel: 'Affiliate Level',
      status: 'Status',
      totalCommission: 'Total Commission',
      availableCommission: 'Available Commission',
      withdrawnCommission: 'Withdrawn Commission',
      teamCount: 'Team Count',
      auditReason: 'Audit Reason',
      createTime: 'Create Time',
      level1: 'Level 1',
      level2: 'Level 2',
      pendingReview: 'Pending Review',
      approved: 'Approved',
      rejected: 'Rejected',
      affiliateApply: 'Affiliate Apply',
      applyTime: 'Apply Time',
      affiliateApplyAudit: 'Affiliate Apply Audit',
      applyDesc: 'Apply Description',
      pleaseAudit: 'Please Audit',
      pass: 'Pass',
      reject: 'Reject',
      reason: 'Reason',
      pleaseInputReason: 'Please input reason',
      pleaseSelectAuditStatus: 'Please select audit status',
      // modify by java110 at 2026-08-01 新增支付状态相关翻译
      payStatus: 'Pay Status',
      payAmount: 'Pay Amount',
      payTime: 'Pay Time',
      paid: 'Paid',
      unpaid: 'Unpaid'
    },
    deleteAffiliateUser: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteAffiliateUser: 'Confirm to delete affiliate user',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    affiliateUserManage: {
      queryCondition: '查询条件',
      pleaseInputAffiliateUser: '请填写分销员',
      query: '查询',
      affiliateUser: '分销员',
      affiliateUserId: '分销员ID',
      ruleId: '规则ID',
      relatedUserId: '关联用户ID',
      parentAffiliateUserId: '上级分销员ID',
      parentAffiliateUser: '上级分销员',
      affiliateLevel: '分销等级',
      status: '状态',
      totalCommission: '累计佣金',
      availableCommission: '可提现佣金',
      withdrawnCommission: '已提现佣金',
      teamCount: '团队人数',
      auditReason: '审核原因',
      createTime: '创建时间',
      level1: '一级',
      level2: '二级',
      pendingReview: '待审核',
      approved: '审核通过',
      rejected: '已拒绝',
      affiliateApply: '分销申请',
      applyTime: '申请时间',
      affiliateApplyAudit: '分销申请审核',
      applyDesc: '申请说明',
      pleaseAudit: '请审核',
      pass: '通过',
      reject: '拒绝',
      reason: '原因',
      pleaseInputReason: '请输入原因',
      pleaseSelectAuditStatus: '请选择审核状态',
      // modify by java110 at 2026-08-01 新增支付状态相关翻译
      payStatus: '支付状态',
      payAmount: '支付金额',
      payTime: '支付时间',
      paid: '已支付',
      unpaid: '待支付'
    },
    deleteAffiliateUser: {
      confirmOperation: '请确认您的操作',
      confirmDeleteAffiliateUser: '确定删除分销员',
      cancel: '点错了',
      confirmDelete: '确认删除'
    }
  }
}